import { axiosInstance } from './api'

import { EntityPage, Paging } from 'types/paging'
import { SceneGET } from 'types/scenes'

export const scenesApi = {
  paging(params: Paging) {
    return axiosInstance.post<EntityPage<SceneGET>>(`publisher/scenes/paging`, params)
  },
  getOne(id: number) {
    return axiosInstance.get<SceneGET>(`publisher/scenes/${id}`)
  },
  update(id: number, params: FormData) {
    return axiosInstance.put(`publisher/scenes/${id}`, params)
  },
  delete(id: number) {
    return axiosInstance.delete(`publisher/scenes/${id}`)
  },
}
